if (!window.studioCampaignInteractions) {
  window.studioCampaignInteractions = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.sc-preview-trigger');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.dialog);
      if (dialog && !dialog.open) dialog.showModal();
    }
    const dialog = event.target.closest('.sc-product-dialog');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    document.querySelectorAll('.sc-shop-menu[open], .sc-mobile-nav[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.sc-shop-menu[open], .sc-mobile-nav[open]').forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('play', (event) => {
    if (event.target.matches('.sc-film video')) document.querySelectorAll('.sc-film video').forEach(video => {
      if (video !== event.target) video.pause();
    });
  }, true);
}
